import {
  ECustomRangeType,
  TAbsoluteTimeUnit,
  TRelativeTimeUnit, TSkipButtonTranslations,
} from '@/components/date-range-picker/date-range-picker.ts';

const timeUnits: Record<TRelativeTimeUnit | TAbsoluteTimeUnit, string> = {
  day: 'Datum',
  days: 'Tag | Tage',
  hours: 'Stunde | Stunden',
  isoWeek: 'Kalenderwoche | Kalenderwochen',
  minutes: 'Minute | Minuten',
  months: 'Monat | Monate',
  quarters: 'Quartal | Quartale',
  weeks: 'Woche | Wochen',
  years: 'Jahr | Jahre',
};

const timeUnitsShort: Record<TRelativeTimeUnit | TAbsoluteTimeUnit, string> = {
  day: '',
  days: 'T',
  hours: 'Std',
  isoWeek: 'KW',
  minutes: 'Min',
  months: 'M',
  quarters: 'Q',
  weeks: 'W',
  years: 'J',
};

const header: Record<ECustomRangeType, string> = {
  [ECustomRangeType.ABSOLUTE]: 'Absolut',
  [ECustomRangeType.CUSTOM]: 'Benutzerdefiniert',
  [ECustomRangeType.RELATIVE]: 'Relativ',
  [ECustomRangeType.BY_JOB]: 'Nach Charge',
};

const skipButtonTranslations: TSkipButtonTranslations = {
  next: '{formattedDuration} vorwärts, zu {to}',
  previous: '{formattedDuration} zurück, zu {to}',
};

const skipButtonTranslationsByJob: TSkipButtonTranslations = {
  next: 'Zur nächsten Charge wechseln',
  previous: 'Zur vorherigen Charge wechseln',
};

const directions: Record<'past' | 'future', string> = {
  past: 'Zurück',
  future: 'Vorraus',
};

export default {
  header,
  jobLabel: 'Charge',
  lastJobLabel: 'Letzte Charge',
  useLastJob: 'Letzte Charge verwenden',
  convertToCustom: 'Zu Benutzerdefiniert umwandeln',
  custom: 'Benutzerdefiniert',
  currentWeek: 'aktuelle Woche',
  previousWeek: 'vorherige Woche',
  nextWeek: 'nächste Woche',
  calendarWeek: 'KW',
  rangeInvalidHint: 'Der gewählte Zeitraum ist entweder größer als der maximal zulässige Zeitraum {maxDuration} oder die gewählten Daten sind außerhalb des zugelassenen bereichs von {minDate} - {maxDate}.',
  rangeFrom: 'Von',
  rangeTo: 'Bis',
  timeUnit: 'Zeiteinheit',
  all: 'Alles',
  timeUnits,
  timeUnitsShort,
  skipButtonTranslations,
  skipButtonTranslationsByJob,
  directions,
};
